"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _theme = require("../../theme");

var _default = {
  MuiTypography: {
    body1: {
      fontSize: "1rem"
    },
    body2: {
      fontSize: "0.875rem"
    },
    body3: {
      fontSize: "0.75rem"
    },
    button: {
      fontSize: "0.75rem",
      fontWeight: "bold",
      textTransform: "none"
    },
    caption: {
      fontSize: "0.75rem",
      lineHeight: 1
    },
    chip: {
      fontSize: "0.875rem",
      fontWeight: "bold"
    },
    gutterBottom: {
      marginBottom: _theme.spacing[1]
    },
    h1: {
      fontSize: "1.5rem",
      fontWeight: "bold"
    },
    h2: {
      fontSize: "1.375rem",
      fontWeight: "bold"
    },
    h3: {
      fontSize: "1.25rem",
      fontWeight: "bold"
    },
    h4: {
      fontSize: "1.125rem",
      fontWeight: "bold"
    },
    root: {
      color: _theme.palette.brand.grey.charcoal
    },
    subtitle1: {
      fontSize: "1rem",
      fontWeight: "bold"
    },
    subtitle2: {
      fontSize: "0.875rem",
      fontWeight: "bold"
    }
  }
};
exports.default = _default;